import { push } from "connected-react-router";
import { useCallback, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { ROUTE_PATH } from "../../app/constants";
import { fullName } from "../../app/utils";
import { Header, Button } from "../../components/RegularComponents";
import { mraBrokerNextStepSelect } from "../../redux/selector/mraBrokerNextStepSelector";
import { mraPrincipalBrokerSelector } from "../../redux/selector/mraPrincipalBrokerSelector";
import { setCurrentAgentApplicationId } from "../../redux/slice/additionalApplicationsSlice";
import { fetchApplicationWithIdAndSetStore } from "../../redux/slice/collectionApplicationSlice";
import { IsInternalId } from "../../redux/slice/primaryAgencyApplicationSlice";
import TopNavigationBar from "../TopNavigationBar";

const BrokerNextSteps = (props) => {
  const dispatch = useDispatch();

  const { mraBrokerNextStep } = props;
  const {
    applicationId,
    businessLicenceData,
    companyRjscDetails,
    principalBrokerApplicationReview,
    agencyApplicationReview,
    principalBrokerDutiesConfirmation,
  } = mraBrokerNextStep;

  const {
    mainBusinessContact = {},
    financialRecordsLocation = {},
    companyFiscalEndDate = 0,
    serviceBusinessAddress = {},
    responsibleAgent = {}
  } = businessLicenceData;

  const { principalBrokerApplication } = useSelector(
    mraPrincipalBrokerSelector
  );
  const mraApplicationState =
    principalBrokerApplication?.businessLicenceData ?? {};

  const { personData, confirmCompletionRegulatoryInfo } = mraApplicationState;

  const style = {
    successStep: {
      backgroundColor: "white",
      borderStyle: "solid",
      borderWidth: "1px",
      color: "green",
      left: "-45px",
    },
    toDoStep: {
      backgroundColor: "white",
      borderStyle: "solid",
      borderWidth: "1px",
      color: "gray",
      left: "-45px",
    },
    rowSpacer: {
      marginTop: "20px",
    },
    contentSpacer: {
      marginLeft: "25px",
    },
  };

  const isRjscStepDone = useCallback(() => {
    if (
      companyRjscDetails &&
      companyRjscDetails.businessEntity &&
      companyRjscDetails.businessEntity.registryNumber
    ) {
      return true;
    }

    return false;
  }, [companyRjscDetails]);

  const isBrokerStepDone = useCallback(() => {
    // console.log(
    //   "What is our data?",
    //   principalBrokerApplicationReview,
    //   personData,
    //   confirmCompletionRegulatoryInfo
    // );

    if (
      principalBrokerApplicationReview &&
      personData &&
      confirmCompletionRegulatoryInfo
    ) {
      return true;
    }
    return false;
  }, [
    principalBrokerApplicationReview,
    personData,
    confirmCompletionRegulatoryInfo,
  ]);

  const isBrokerageStepDone = useCallback(() => {
    // console.log(
    //   "What is the data?",
    //   mainBusinessContact,
    //   financialRecordsLocation,
    //   appointedAgentServiceAddress,
    //   companyFiscalEndDate,
    //   uploadCriminalRecordCheck,
    //   uploadedProofOfInsurance,
    //   principalBrokerDutiesConfirmation,
    //   agencyApplicationReview
    // );

    // TODO : add documents check for completion.
    if (
      (mainBusinessContact && Object.keys(mainBusinessContact).length) > 0 &&
      (financialRecordsLocation && Object.keys(financialRecordsLocation).length) > 0 &&
      (responsibleAgent && Object.keys(responsibleAgent).length > 0) &&
      (serviceBusinessAddress && Object.keys(serviceBusinessAddress).length) > 0 &&
      companyFiscalEndDate &&
      principalBrokerDutiesConfirmation > 0 &&
      agencyApplicationReview > 0
    ) {
      return true;
    }
    return false;
  }, [
    mainBusinessContact,
    financialRecordsLocation,
    responsibleAgent,
    serviceBusinessAddress,
    companyFiscalEndDate,
    // uploadCriminalRecordCheck,
    // uploadedProofOfInsurance,
    principalBrokerDutiesConfirmation,
    agencyApplicationReview,
  ]);

  const isMoreBrokerStepDone = () => {
    return false;
  };

  const stepDone = (step) => {
    switch (step) {
      case 1:
        return isRjscStepDone();
      case 2:
        return isBrokerStepDone();
      case 3:
        return isBrokerageStepDone();
      case 4:
        return isMoreBrokerStepDone();
      case 5:
        return (
          isRjscStepDone() &&
          isBrokerStepDone() &&
          isBrokerageStepDone() &&
          isMoreBrokerStepDone()
        );
      default:
        return false;
    }
  };

  const isStepCurrent = (step) => {
    switch (step) {
      case 1:
        return (
          !isRjscStepDone() &&
          !isBrokerStepDone() &&
          !isBrokerageStepDone() &&
          !isMoreBrokerStepDone()
        );
      case 2:
        return (
          isRjscStepDone() &&
          !isBrokerStepDone() &&
          !isBrokerageStepDone() &&
          !isMoreBrokerStepDone()
        );
      case 3:
        return (
          isRjscStepDone() &&
          isBrokerStepDone() &&
          !isBrokerageStepDone() &&
          !isMoreBrokerStepDone()
        );
      case 4:
        return (
          isRjscStepDone() &&
          isBrokerStepDone() &&
          isBrokerageStepDone() &&
          !isMoreBrokerStepDone()
        );
      case 5:
        return (
          isRjscStepDone() &&
          isBrokerStepDone() &&
          isBrokerageStepDone() &&
          isMoreBrokerStepDone()
        );
      default:
        return false;
    }
  };

  useEffect(() => {
    if (!businessLicenceData 
        && applicationId 
        && !IsInternalId(applicationId)) {
      dispatch(fetchApplicationWithIdAndSetStore(applicationId));
    }
  }, [applicationId, businessLicenceData, dispatch]);

  return (
    <>
      <div className={"container"}>
        <TopNavigationBar {...props} />
        <div className="row">
          <div className="col-xs-12 col-lg-11">
            <Header
              id="broker-next-steps-header"
              header="Steps to complete your Mortgage Brokerage Licence application"
            />
          </div>
        </div>

        <div style={style.contentSpacer} className="timeline row">
          <ol>
            <li className="timeline-item col-md-12">
              <div
                className={`step-content col-md-12 col-xs-12 ${
                  stepDone(1) ? "step-content-success" : "step-content-todo"
                }`}
              >
                <span
                  style={stepDone(1) ? style.successStep : style.toDoStep}
                  className="step-counter"
                >
                  <span style={{ margin: "10px" }}>Step 1</span>
                  {stepDone(1) ? (
                    <i
                      className="fa fa-check-circle"
                      style={{ fontSize: "19px" }}
                      aria-hidden="true"
                    ></i>
                  ) : isStepCurrent(1) ? (
                    <>&gt;</>
                  ) : null}
                </span>
                <div className="row">
                  <div style={style.contentSpacer} className="col-lg-11">
                    <span style={{ fontSize: "25px" }}>
                      Provide your company information
                    </span>
                  </div>
                </div>
                <div className="row">
                  <div style={style.contentSpacer} className="col-lg-11">
                    <span>
                    {`If your company is registered with the Nova Scotia Registry of Joint Stock Companies (RJSC), 
                    you can enter your company name or RJSC number to review your company information 
                    that was already provided. A small number of companies are not registered with RJSC. 
                    These companies will need to enter their company information manually.`}
                    </span>
                  </div>
                </div>
                {(isStepCurrent(1) || stepDone(1)) && (
                  <div className="row">
                    <div style={style.contentSpacer} className="col-lg-11">
                      <Button
                        style={{ marginTop: "20px" }}
                        buttonType={"regular_primary"}
                        text={stepDone(1) ? "Review your answers" : "Start now"}
                        onClick={() => {
                          if(stepDone(1)) {
                            // mra/mra-review-business-info
                            dispatch(
                              push(
                                `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_RJSC_DETAIL_REVIEW}`
                              )
                            );
                          } else { 
                            dispatch(
                              push(
                                `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_RJSC_SEARCH}`
                              )
                            );
                          }
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </li>

            <li className="timeline-item col-md-12">
              <div
                className={`step-content col-md-12 col-xs-12 ${
                  stepDone(2) ? "step-content-success" : "step-content-todo"
                }`}
              >
                <span
                  style={stepDone(2) ? style.successStep : style.toDoStep}
                  className="step-counter"
                >
                  <span style={{ margin: "10px" }}>Step 2</span>
                  {stepDone(2) ? (
                    <i
                      className="fa fa-check-circle"
                      style={{ fontSize: "19px" }}
                      aria-hidden="true"
                    ></i>
                  ) : isStepCurrent(2) ? (
                    <>&nbsp;&gt;</>
                  ) : null}
                </span>
                <div className="row">
                  <div style={style.contentSpacer} className="col-lg-11">
                    <span style={{ fontSize: "25px" }}>
                      Complete an application for Mortgage Broker Licence
                    </span>
                  </div>
                  <div style={style.contentSpacer} className="col-lg-11">
                    <span>
                      Before you can apply for a brokerage licence, you need to
                      complete a Mortgage Broker licence application for
                      yourself, as the Principal Broker.
                    </span>
                  </div>
                </div>
                {(isStepCurrent(2) || stepDone(2)) && (
                  <div className="row">
                    <div style={style.contentSpacer} className="col-lg-11">
                      <Button
                        style={{ marginTop: "20px" }}
                        buttonType={"regular_primary"}
                        text={stepDone(2) ? "Review your answers" : "Start now"}
                        onClick={() => {
                          let nextUrl = ROUTE_PATH.MRA_SELECT_PRINCIPAL_BROKER_FROM_LIST

                          if(fullName(personData)) {
                            nextUrl = ROUTE_PATH.MRA_PREVIOUSLY_LICENCED_MORTGAGE_BROKER
                            dispatch(setCurrentAgentApplicationId(principalBrokerApplication?.id))
                          }
                          
                          dispatch(
                            push(
                              `${ROUTE_PATH.MRA_APP}${nextUrl}`
                            )
                          );
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </li>

            <li className="timeline-item col-md-12">
              <div
                className={`step-content col-md-12 col-xs-12 ${
                  stepDone(3) ? "step-content-success" : "step-content-todo"
                }`}
              >
                <span
                  style={stepDone(3) ? style.successStep : style.toDoStep}
                  className="step-counter"
                >
                  <span style={{ margin: "10px" }}>Step 3</span>
                  {stepDone(3) ? (
                    <i
                      className="fa fa-check-circle"
                      style={{ fontSize: "19px" }}
                      aria-hidden="true"
                    ></i>
                  ) : isStepCurrent(3) ? (
                    <>&nbsp;&gt;</>
                  ) : null}
                </span>
                <div className="row">
                  <div style={style.contentSpacer} className="col-lg-11">
                    <span style={{ fontSize: "25px" }}>
                      Complete an application for Mortgage Brokerage Licence
                    </span>
                  </div>
                  <div style={style.contentSpacer} className="col-lg-11">
                    <span>
                      Next, you'll provide more information about your company
                      as part of your Mortgage Brokerage Application
                    </span>
                  </div>
                </div>
                {(isStepCurrent(3) || stepDone(3)) && (
                  <div className="row">
                    <div style={style.contentSpacer} className="col-lg-11">
                      <Button
                        style={{ marginTop: "20px" }}
                        buttonType={"regular_primary"}
                        text={stepDone(3) ? "Review your answers" : "Start now"}
                        onClick={() => {
                          // On to the next item
                          dispatch(
                            push(
                              `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_COMPANY_CONTACT_INFO}`
                            )
                          );
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </li>

            <li className="timeline-item col-md-12">
              <div
                className={`step-content col-md-12 col-xs-12 ${
                  stepDone(4) ? "step-content-success" : "step-content-todo"
                }`}
              >
                <span
                  style={stepDone(4) ? style.successStep : style.toDoStep}
                  className="step-counter"
                >
                  <span style={{ margin: "10px" }}>Step 4</span>
                  {stepDone(4) ? (
                    <i
                      className="fa fa-check-circle"
                      style={{ fontSize: "19px" }}
                      aria-hidden="true"
                    ></i>
                  ) : isStepCurrent(4) ? (
                    <>&nbsp;&gt;</>
                  ) : null}
                </span>
                <div className="row">
                  <div style={style.contentSpacer} className="col-lg-11">
                    <span style={{ fontSize: "25px" }}>
                      Apply for more Mortgage Broker and Associate Broker
                      licences, or pay for your applications
                    </span>
                  </div>
                </div>
                <div style={style.rowSpacer} className="row">
                  <div style={style.contentSpacer} className="col-lg-11">
                    <span>
                      If your company has other people who require Mortgage
                      Broker or Associate Mortgage Broker licences, you can
                      apply for them now. Or, pay for your completed
                      applications and come back later.
                    </span>
                  </div>
                </div>
                <div style={style.rowSpacer} className="row">
                  <div style={style.contentSpacer} className="col-lg-11">
                    <span>
                      You can pay for your application by credit card (VISA,
                      Mastercard, American Express) or credit/debit cards (a
                      debit card with the Visa or Mastercard logo).
                    </span>
                  </div>
                </div>
                {isStepCurrent(4) && (
                  <div className="row">
                    <div style={style.contentSpacer} className="col-lg-11">
                      <Button
                        style={{ marginTop: "20px" }}
                        buttonType={"regular_primary"}
                        text={"Start now"}
                        onClick={() => {
                          // On to the next item
                          dispatch(
                            push(
                              `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_ADD_BROKERS_TO_BROKERAGE}`
                            )
                          );
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </li>

            <li className="timeline-item col-md-12">
              <div className="step-content step-content-no-border col-md-12 col-xs-12">
                <span
                  style={stepDone(5) ? style.successStep : style.toDoStep}
                  className="step-counter"
                >
                  <span style={{ margin: "10px" }}>Step 5</span>
                  {stepDone(5) ? (
                    <i
                      className="fa fa-check-circle"
                      style={{ fontSize: "19px" }}
                      aria-hidden="true"
                    ></i>
                  ) : isStepCurrent(5) ? (
                    <>&nbsp;&gt;</>
                  ) : null}
                </span>
                <div className="row">
                  <div style={style.contentSpacer} className="col-lg-11">
                    <span style={{ fontSize: "25px" }}>
                      Your applications are submitted and will be reviewed
                    </span>
                  </div>
                </div>
                <div style={style.rowSpacer} className="row">
                  <div style={style.contentSpacer} className="col-lg-11">
                    <span>
                      To see your licence status, go to the home page of Nova
                      Scotia Mortgage Licensing Service. When your licence is
                      reviewed, you'll receive a notification by email from the
                      Business Licensing team and Service Nova Scotia and
                      Internal Services.
                    </span>
                  </div>
                </div>
                <div style={style.rowSpacer} className="row">
                  <div style={style.contentSpacer} className="col-lg-11">
                    <span>
                      When your licence is approved, you'll be able to download
                      a pdf copy from your home page at any time.
                    </span>
                  </div>
                </div>
              </div>
            </li>
          </ol>
        </div>
      </div>
    </>
  );
};

export default connect(mraBrokerNextStepSelect)(BrokerNextSteps);
